/**
 * Строки CRUD-экранов кабинета: услуги, специалисты, часы работы, отпуска.
 *
 * Отдельный файл — см. пояснение в `dict.business.ts`.
 */

export const SETTINGS_STRINGS = {
  // ── Услуги ──
  srvTitle: ['Услуги и цены', 'Xizmatlar va narxlar'],
  srvAdd: ['Добавить услугу', 'Xizmat qoʻshish'],
  srvEdit: ['Изменить услугу', 'Xizmatni oʻzgartirish'],
  srvNameRu: ['Название (RU)', 'Nomi (RU)'],
  srvNameUz: ['Название (UZ)', 'Nomi (UZ)'],
  srvDuration: ['Длительность, мин', 'Davomiyligi, daq'],
  srvPrice: ['Цена, сум', 'Narxi, soʻm'],
  /* Ограничения клиентов (ТЗ §19, №23). Узбекский требует проверки носителем. */
  setBlacklist: ['Ограничения клиентов', 'Mijozlar cheklovlari'],
  blTitle: ['Ограничения клиентов', 'Mijozlar cheklovlari'],
  blSection: ['Сейчас не принимаются', 'Hozir qabul qilinmaydi'],
  blEmpty: [
    'Ограничений нет. Сюда попадают клиенты после второй неявки у вас.',
    'Cheklovlar yoʻq. Bu yerga sizdagi ikkinchi kelmaslikdan keyin mijozlar tushadi.',
  ],
  blNote: [
    'Снятие убирает ограничение только у вас. Отметка о неявке остаётся, и следующая неявка закроет запись снова.',
    'Olib tashlash cheklovni faqat sizda bekor qiladi. Kelmaganlik belgisi qoladi va keyingi kelmaslik yozilishni yana yopadi.',
  ],
  blUntil: ['До {date}', '{date} gacha'],
  blForever: ['Без срока', 'Muddatsiz'],
  blLift: ['Снять', 'Olib tashlash'],
  srvEmpty: ['Услуг пока нет. Добавьте первую.', 'Xizmatlar hali yoʻq. Birinchisini qoʻshing.'],
  /* Подсказка узбекского поля узбекская в ОБЕИХ локалях: поле хранит узбекское название
     услуги независимо от того, на каком языке владелец сейчас смотрит кабинет. */
  srvErrName: [
    'Заполните название на обоих языках: клиент видит его на своём.',
    'Nomni ikkala tilda toʻldiring: mijoz uni oʻz tilida koʻradi.',
  ],
  srvErrDuration: [
    'Длительность — целое число минут больше нуля.',
    'Davomiylik — noldan katta butun daqiqa soni.',
  ],
  srvErrPrice: ['Цена — целое число сум, не меньше нуля.', 'Narx — noldan kam boʻlmagan butun son.'],

  // ── Специалисты ──
  stfTitle: ['Специалисты', 'Mutaxassislar'],
  stfAdd: ['Добавить специалиста', 'Mutaxassis qoʻshish'],
  stfEdit: ['Изменить специалиста', 'Mutaxassisni oʻzgartirish'],
  stfName: ['Имя', 'Ism'],
  stfEmpty: [
    'Специалистов пока нет. Добавьте первого.',
    'Mutaxassislar hali yoʻq. Birinchisini qoʻshing.',
  ],
  stfPh: ['Азиз', 'Aziz'],
  /* Специализация. Ключ `stfTitle2`, потому что `stfTitle` уже занят заголовком экрана. */
  stfTitle2: ['Специализация', 'Mutaxassislik'],
  stfTitleNote: [
    'Необязательно. Показывается под именем — клиенту в записи и в каталоге.',
    'Majburiy emas. Ism ostida koʻrsatiladi — mijozga yozuvda va katalogda.',
  ],
  stfErrName: ['Укажите имя специалиста.', 'Mutaxassis ismini kiriting.'],
  /* Название специалиста отраслевое (ТЗ §3): мастер, врач, преподаватель. Термин берётся
     из пресета — это единственное, для чего пресет читать МОЖНО (AGENTS.md, правило 5:
     правила организации лежат в её строке, а термин и иконка — нет). */
  stfAddTerm: ['Добавить: {term}', 'Qoʻshish: {term}'],
  stfEditTerm: ['Изменить: {term}', 'Oʻzgartirish: {term}'],

  // ── Общее для услуг и специалистов ──
  /* Удаления в API нет вовсе: у записей внешний ключ с `onDelete: Restrict`, и «удалить»
     работало бы у новой услуги и падало бы у той, по которой уже приходили. Плюс история
     визитов клиента не должна разваливаться от кадровых решений. */
  itemActive: ['Активна', 'Faol'],
  itemInactive: ['Выключена', 'Oʻchirilgan'],
  itemEnable: ['Включить', 'Yoqish'],
  itemDisable: ['Выключить', 'Oʻchirish'],
  itemNoDelete: [
    'Удаления нет: выключенная позиция исчезает из записи, но остаётся в истории визитов.',
    'Oʻchirish yoʻq: oʻchirilgan pozitsiya yozuvdan yoʻqoladi, lekin tashriflar tarixida qoladi.',
  ],
  /* Сервис намеренно НЕ отменяет записи выключенного мастера сам: отмена шлёт клиенту
     уведомление и делается по каждой осознанно (ТЗ §11.4). Единственный способ узнать
     о них у владельца — это предупреждение. */
  staffOffWarnT: ['Специалист выключен', 'Mutaxassis oʻchirildi'],
  staffOffWarn: [
    'У специалиста остаётся будущих записей: {count}. Они не отменены — отмените каждую вручную, если он не выйдет.',
    'Mutaxassisda kelgusi yozuvlar qoldi: {count}. Ular bekor qilinmadi — chiqmasa, har birini qoʻlda bekor qiling.',
  ],
  /* Организация опубликована, но активных услуг или специалистов не осталось: карточка
     в каталоге есть, а записаться не на что. Бэкенд НЕ снимает публикацию сам — снять
     легко, вернуть некому, — поэтому исправить может только владелец, и здесь ему
     называются оба способа: включить обратно или скрыть организацию. */
  bizEmptyShelfT: ['Записаться не на что', 'Yozilish uchun hech narsa yoʻq'],
  bizEmptyShelf: [
    'Организация осталась в каталоге, но записаться в неё нельзя: не осталось ни активных услуг, ни активных специалистов. Включите обратно или снимите организацию с публикации в настройках.',
    'Tashkilot katalogda qoldi, lekin unga yozilib boʻlmaydi: na faol xizmat, na faol mutaxassis qoldi. Qaytadan yoqing yoki sozlamalarda tashkilotni nashrdan oling.',
  ],
  itemSave: ['Сохранить', 'Saqlash'],
  itemCancel: ['Отмена', 'Bekor qilish'],

  // ── Часы работы ──
  schTitle: ['Часы работы', 'Ish vaqti'],
  schBusinessLevel: ['Часы организации', 'Tashkilot ish vaqti'],
  schStaffLevel: ['Личные часы', 'Shaxsiy ish vaqti'],
  /* Личные часы ПЕРЕКРЫВАЮТ часы организации, а не складываются с ними. Пустой личный
     набор означает «работает по часам организации», а не «не работает». */
  schStaffNote: [
    'Личные часы заменяют часы организации. Пусто — специалист работает по часам организации.',
    'Shaxsiy ish vaqti tashkilot vaqtini almashtiradi. Boʻsh — mutaxassis tashkilot vaqti boʻyicha ishlaydi.',
  ],
  /* Переключатель источника расписания. Пока он выключен, личные часы не действуют вовсе;
     включённый — делает пустой день ВЫХОДНЫМ. Ради этого он и заведён: иначе «Акбар
     не работает по средам» выразить нечем, кроме как закрыв среду всей организации. */
  schOwnToggle: ['Свой график', 'Shaxsiy jadval'],
  schOwnOnNote: [
    'Работает по своим часам. День без интервалов — выходной у этого специалиста.',
    'Oʻz vaqti boʻyicha ishlaydi. Intervalsiz kun — bu mutaxassisning dam olish kuni.',
  ],
  schOwnOffNote: [
    'Работает по часам организации. Включите свой график, чтобы задать ему отдельные дни и выходные.',
    'Tashkilot vaqti boʻyicha ishlaydi. Alohida kunlar va dam olish uchun shaxsiy jadvalni yoqing.',
  ],
  /* Личные часы при выключении НЕ удаляются — переключатель обратим, и об этом надо сказать:
     иначе владелец побоится его трогать, решив, что потеряет набранную неделю. */
  schOwnKeepNote: [
    'Часы сохраняются: выключите и включите обратно — неделя останется прежней.',
    'Vaqt saqlanadi: oʻchirib yoqsangiz, hafta oʻzgarmaydi.',
  ],
  schClosed: ['Выходной', 'Dam olish kuni'],
  schAddInterval: ['Добавить интервал', 'Interval qoʻshish'],
  schFrom: ['С', 'Dan'],
  schTo: ['До', 'Gacha'],
  schEmpty: ['Часы не заданы — записи невозможны.', 'Ish vaqti belgilanmagan — yozuv imkonsiz.'],
  schLevelTitle: ['Чьи часы', 'Kimning ish vaqti'],
  schWeek: ['Неделя', 'Hafta'],
  schEditDay: ['Часы дня', 'Kun vaqti'],
  schDayDone: ['Готово', 'Tayyor'],
  schRemoveInterval: ['Убрать интервал', 'Intervalni olib tashlash'],
  schSave: ['Сохранить неделю', 'Haftani saqlash'],
  schSaved: ['Часы сохранены.', 'Ish vaqti saqlandi.'],
  /* Кнопка сохранения — единственный момент, когда неделя уходит на сервер: `replaceSchedule`
     заменяет уровень целиком, поэтому правка дня сама по себе ничего не сохраняет. */
  schDirty: [
    'Изменения не сохранены. Нажмите «Сохранить неделю».',
    'Oʻzgarishlar saqlanmadi. «Haftani saqlash»ni bosing.',
  ],
  /* У рабочих часов нет даты — только день недели и минуты от полуночи В ПОЯСЕ ОРГАНИЗАЦИИ
     (AGENTS.md, правило 1). Владелец, который правит часы из другого города, обязан это видеть. */
  schTzNote: ['Время в поясе организации: {tz}.', 'Vaqt tashkilot mintaqasida: {tz}.'],

  // ── Дни недели. Индекс = weekday, 0 = воскресенье, как в JS Date.getDay() ──
  dow0: ['Воскресенье', 'Yakshanba'],
  dow1: ['Понедельник', 'Dushanba'],
  dow2: ['Вторник', 'Seshanba'],
  dow3: ['Среда', 'Chorshanba'],
  dow4: ['Четверг', 'Payshanba'],
  dow5: ['Пятница', 'Juma'],
  dow6: ['Суббота', 'Shanba'],

  // ── Отпуска ──
  offTitle: ['Отпуска и отсутствия', 'Taʼtil va yoʻqliklar'],
  offAdd: ['Добавить отсутствие', 'Yoʻqlik qoʻshish'],
  offStaff: ['Специалист', 'Mutaxassis'],
  offFrom: ['Начало', 'Boshlanishi'],
  offTo: ['Конец', 'Tugashi'],
  offReason: ['Причина', 'Sababi'],
  offReasonPh: ['Отпуск', 'Taʼtil'],
  offRemove: ['Удалить', 'Oʻchirish'],
  offEmpty: ['Отсутствий в этом периоде нет.', 'Bu davrda yoʻqliklar yoʻq.'],
  /* Список требует и мастера, и периода: оба параметра обязательны в API. Показать «все
     отсутствия» экран не может — такого запроса нет. */
  offPeriod: ['Период', 'Davr'],
  offAllDay: ['Весь день', 'Butun kun'],
  offTime: ['Время', 'Vaqt'],
  offNoStaff: [
    'Сначала добавьте специалиста: отсутствие ставится конкретному человеку.',
    'Avval mutaxassis qoʻshing: yoʻqlik aniq shaxsga qoʻyiladi.',
  ],
  offErrStaff: ['Выберите специалиста.', 'Mutaxassisni tanlang.'],
  offErrTime: ['Время — в формате ЧЧ:ММ.', 'Vaqt — SS:DD koʻrinishida.'],
  offErrRange: [
    'Конец должен быть позже начала.',
    'Tugash vaqti boshlanishdan keyin boʻlishi kerak.',
  ],
  offRemoveT: ['Удалить отсутствие?', 'Yoʻqlik oʻchirilsinmi?'],
  offRemoveB: [
    'Эти даты снова откроются для записи.',
    'Bu sanalar yozuv uchun yana ochiladi.',
  ],
  /* Отпуск — абсолютный интервал с датами, в отличие от недельного шаблона часов.
     Закрыть один конкретный день правкой часов нельзя: закроется этот день недели навсегда. */
  offNote: [
    'Отсутствие закрывает конкретные даты. Постоянный график меняйте в часах работы.',
    'Yoʻqlik aniq sanalarni yopadi. Doimiy jadvalni ish vaqtida oʻzgartiring.',
  ],
} as const satisfies Record<string, readonly [string, string]>;
